import apisauce from 'apisauce';
import storage from 'redux-persist/lib/storage';

const campaignProposalApiInstance = apisauce.create({
  baseURL: process.env.REACT_APP_CAMPAIGN_PROPOSAL_ENDPOINT,
  headers: {
    'Cache-Control': 'no-cache',
  },
  timeout: 120000,
});

const authRequestTransform = request => async () => {
  const storageHeaders = await storage.getItem('authHeaders');
  if (!storageHeaders) return;

  const headers = JSON.parse(storageHeaders);
  campaignProposalApiInstance.setHeaders(headers);
  request.headers = { ...request.headers, ...headers };
};

campaignProposalApiInstance.addAsyncRequestTransform(authRequestTransform);

export const createCampaignProposals = body => campaignProposalApiInstance.post('/proposals', body);
